import { Link as RouterLink } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import get from 'lodash/get'
import { useTeam } from '../../../../contexts/TeamContext'
import Flex from '../../../../shared/components/layouts/Flex'
import FlexColumn from '../../../../shared/components/layouts/FlexColumn'
import { getNodeStatus, getStatusColor, getLoadLevel, getLoadColor } from '../../../operations/terminal/utils/nodeStatus'

const formatUtilization = (value) => {
  if (value === undefined || value === null) return '-'
  return `${Math.round(value)}%`
}

function DashboardNodeCard({ node }) {
  const { team } = useTeam()
  const status = getNodeStatus(node)
  const latestStatus = get(node, 'latestStatus') || {}
  const loadLevel = getLoadLevel(latestStatus)

  return (
    <Box
      component={RouterLink}
      to={`/teams/${team.slug}/nodes/${node.id}`}
      sx={{
        display: 'block',
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        p: 2,
        textDecoration: 'none',
        color: 'inherit',
        '&:hover': {
          bgcolor: 'action.hover',
          textDecoration: 'none',
        },
      }}
    >
      <Flex alignItems="center" gap={2}>
        <Box
          sx={{
            width: 12,
            height: 12,
            flexShrink: 0,
            borderRadius: '50%',
            bgcolor: status === 'online' ? getLoadColor(loadLevel) : 'grey.500',
          }}
        />
        <FlexColumn gap={0.5} sx={{ flexGrow: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
            {node.name}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'monospace' }}>
            {node.ip || '-'}
          </Typography>
        </FlexColumn>
        <Chip
          label={<FormattedMessage id={`nodes.status.${status}`} />}
          color={getStatusColor(status)}
          size="small"
        />
      </Flex>

      <Flex gap={3} sx={{ mt: 2, justifyContent: 'space-around' }}>
        <FlexColumn alignItems="center" gap={0.5}>
          <Typography variant="caption" color="text.secondary">
            <FormattedMessage id="dashboard.nodes.metrics.cpu" />
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
            {formatUtilization(latestStatus.cpuUtilization)}
          </Typography>
        </FlexColumn>
        <FlexColumn alignItems="center" gap={0.5}>
          <Typography variant="caption" color="text.secondary">
            <FormattedMessage id="dashboard.nodes.metrics.memory" />
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
            {formatUtilization(latestStatus.memoryUtilization)}
          </Typography>
        </FlexColumn>
        <FlexColumn alignItems="center" gap={0.5}>
          <Typography variant="caption" color="text.secondary">
            <FormattedMessage id="dashboard.nodes.metrics.disk" />
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
            {formatUtilization(latestStatus.diskUtilization)}
          </Typography>
        </FlexColumn>
      </Flex>
    </Box>
  )
}

export default DashboardNodeCard
